import { HttpErrorResponse } from '@angular/common/http';

export class DeleteProfilePictureFailure {
    static readonly type = '[User] DeleteProfilePictureFailure';

    constructor(public payload: { response: HttpErrorResponse }) {}
}
